import { render } from "./LatestProductReviews.vue?vue&type=template&id=64207d08"
import script from "./LatestProductReviews.vue?vue&type=script&lang=js"
export * from "./LatestProductReviews.vue?vue&type=script&lang=js"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__